<div class="modal-header">
    <h6 class="modal-title pull-left"> {{updateId==''?'Add':'Edit' }} Event</h6>
    <button type="button" class="close btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>


<div class="modal-body">
    <div class="row">
        <div class="col-md-12 col-sm-12">
            <div class="form-group">
                <label for="ID">Event Name</label>
                <input type="text" id="orgname" placeholder="Enter Event Name" class="form-control"
                    [(ngModel)]="addOrgObj.org_name">
            </div>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="form-group">
                <label for="ID">No. of Person</label>
                <input type="number" id="orgname" placeholder="Enter No. of Person" class="form-control"
                    [(ngModel)]="addOrgObj.person">
            </div>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="ID">Event Start On</label> <br>
              <input class="form-control divide" placeholder="yyyy-mm-dd" name="dp" [(ngModel)]="ddate" ngbDatepicker
                #d="ngbDatepicker" (click)="d.toggle();" (ngModelChange)="dateChange()" [minDate]="todayDate">
            </div>
          </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger btn-sm" (click)="activeModal.dismiss()">Cancel</button>&nbsp;
    <button type="button" class="btn btn-primary btn-sm" (click)="save()">Save</button>
</div>